export var ourSolutionsInfo = {
    fmPro: {
        brochureUrl: "/media/Brochures2026/FMPro.26.1.pdf",
        videoUrl: "https://youtu.be/DKHa92e6ECg",
    }
}